module.exports = "/_next/static/images/40-1-11ffbd44b992fd588eef83dd7e913e4e.jpg";